import { AppState, PostPageKyivAppState } from '../../initialStateRegistration';

const getPostPage = (state: AppState) => (state as PostPageKyivAppState).template;

export const getRecommendationsTitle = (state: AppState) => getPostPage(state).recommendationsSectionTitle;

export const getRecommendationsArticles = (state: AppState) => getPostPage(state).recommendationsSectionArticles;
